<template>
    <div class="cabinet-content-wrap">
        <HeaderPublic />

        <section class="cabinet__breadcrumbs">
            <router-link to="/" class="cabinet__breadcrumbs-link"
                >Главная</router-link
            >
            <span class="cabinet__breadcrumbs-arrow">&rsaquo;</span>
            <router-link to="/catalog" class="cabinet__breadcrumbs-link"
                >Каталог</router-link
            >
        </section>

        <div class="cabinet__product-page">
            <h1 class="h1">Каталог ювелирных изделий</h1>

            <p v-if="!categories">Loading...</p>

            <template v-else>
                <div class="cabinet__product-list_wrap mt-4 pt-2">
                    <ul class="cabinet__product-list flex-wrap">
                        <li
                            v-for="categorie in categories"
                            :key="categorie.id"
                            class="cabinet__product-list__product-item"
                        >
                            <router-link
                                :to="{
                                    name: 'CategoryID',
                                    params: { id: categorie.url }
                                }"
                            >
                                <div
                                    class="cabinet__product-list__product-item__img"
                                >
                                    <img
                                        v-if="categorie.image_url"
                                        :src="categorie.image_url"
                                        :alt="categorie.Name"
                                    />
                                    <img
                                        v-else
                                        src="/img/no-photo.jpg"
                                        :alt="categorie.name"
                                    />
                                </div>
                                <h4
                                    class="cabinet__product-list__product-item__title-h4"
                                >
                                    {{ categorie.name }}
                                </h4>
                            </router-link>
                        </li>
                    </ul>
                </div>
            </template>

            <div class="cabinet__product-list-more">
                <router-link to="/catalog/category/all">Посмотреть все изделия в каталоге</router-link>
            </div>

            <!-- <div class="cabinet__product-page__note">
                <h2 class="h2">SEO текст</h2>
                <p>Выбрать нужное украшение очень просто: достаточно зайти на сайт и заказать в каталоге. Официальный каталог «Русских самоцветов» позволяет сделать это просто и быстро. Информация в нем структурирована, с помощью удобных фильтров можно искать товары по ряду параметров.</p>
                <a href="javascript:void(0)" class="h4">Читать дальше</a>
            </div> -->
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

import HeaderPublic from '@/components/Public/PublicHeader'

export default {
    name: 'PublicCatalog',
    components: {
        HeaderPublic
    },
    computed: {
        ...mapGetters('publicCategories', ['categories']),
    },
    created() {
        document.title = 'Каталог'
    }
}
</script>
